/**
 * A refused InOut write, in the person's words — `inoutRefusalText`, the one
 * reading both citizen apps share, with this app's language and calendar
 * dates: the absence in the way named by its dates, every other refusal its
 * key, never the server's message.
 */
import { inoutRefusalText } from '@tonnie/heroes';
import { useLocale } from '@tonnie/locale';
import { useCallback } from 'react';

export function useInOutRefusalText(): (error: unknown) => string {
  const { t, formatDate } = useLocale();
  return useCallback(
    (error: unknown) =>
      inoutRefusalText(error, {
        t,
        formatDate: (isoDate) => formatDate(isoDate, 'calendarDay'),
      }),
    [t, formatDate]
  );
}
